import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';

import { RxComponent } from '../common/rx.component';

declare var $: any;

@Component({
    selector: 'itpx-reactive-input',
    templateUrl: './reactive-input.component.html',
    styleUrls: ['./reactive-input.component.css']
})
export class ReactiveInputComponent extends RxComponent implements AfterViewInit {

    @Input()
    private name: string;
    @Input()
    private form;
    @Input()
    private config: any;

    @ViewChild('anchor') anchorElement;
    // Only if type is date
    @ViewChild('dateContainer') dateInput;

    private top: number;
    private left: number;
    private isMin: boolean = true;

    private dateChangeListener: any;

    constructor() {
        super();
    }

    ngOnInit() {

        this.config.responsiveThreshold = this.config.responsiveThreshold || 1200;

        // Observable.fromEvent(window, 'resize')
        //     // Initially wait 30 millis for ngSwitch to evaluate
        //     // so we can get the anchor's coordinates
        //     .merge(Observable.of(true).delay(30))
        //     .bindToLifecycle(this)
        //     .subscribe(_ => {
        //         this.isMin = document.body.clientWidth <= this.config.responsiveThreshold;
        //         if (!this.isMin) {
        //             let anchor = this.anchorElement.nativeElement;
        //             this.top = anchor.offsetTop;
        //             this.left = anchor.offsetLeft + anchor.offsetWidth;
        //         }
        //     });
    }

    ngAfterViewInit() {

        if (this.config.type == 'date') {
            let startPicker = $(this.dateInput.nativeElement).datetimepicker({ ignoreReadonly: true, format: 'DD MMM YYYY', useCurrent: false });
            this.dateChangeListener = startPicker.on('dp.change', e => {
                this.form.controls[this.name].setValue(e.date);
                this.form.controls[this.name].markAsDirty();
                $(this.dateInput.nativeElement).data('DateTimePicker').hide();
            });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        // debugger
        // if (this.dateChangeListener) {
        //     $(this.dateInput.nativeElement).remove('dp.change');
        // }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/reactive-input/reactive-input.component.ts